<template>
  <div class="flex-row gap-12 align-items-center flex1">
    <div class="rating-score">{{ averageScore }}</div>
    <div class="flex-column gap-8">
      <StarRating :rating="averageScore" />
      <p class="has-text-grey has-text-size-12">
        {{
          $t("review:featured_reviews.based_on_reviews", {
            count: reviewCount,
          })
        }}
      </p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  score: {
    type: Number,
    required: true,
  },
  reviewCount: {
    type: Number,
    required: true,
  },
});

const averageScore = computed(() => props.score.toFixed(1));
</script>

<style scoped lang="scss">
.rating-score {
  font-size: 40px;
  font-weight: 600;
  line-height: 130%;
}
</style>
